// standard react component 
import './App.css';
import './index.css';
import Titlebar from './Titlebar';
import music from './resources/music.svg';
import logsicon from './resources/logs.svg';
import { useState } from 'react';
import TrafficLogTable from './logs/TrafficLogTable';
import MusicLogTable from './logs/MusicLogTable';
import { fileUploadUrl } from './config';
import useUserStore from './UserStore';

import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

const uploadOptions = [
  { title: 'Log', description: 'Input a music or traffic log file.', direction:  'Upload a music or traffic file', file_specifics: 'either a .log or a dated selector file', current: true },
  { title: 'Audio', description: 'Input a song or commerical audio file.', direction: 'Upload an audio file', file_specifics: 'either an .mp3 or wav file', current: false },
]

function ManualUpload() {
    const [formData, setFormData] = useState({});
    const [renderLogs, setRenderLogs] = useState(false);
    const [renderTraffic, setRenderTraffic] = useState(false);
    const [logs, setLogs] = useState({});
    const [selected, setSelected] = useState(uploadOptions[0])
    const [selectedFileName, setSelectedFileName] = useState('');
    const [isUploading, setIsUploading] = useState(false);
        const user = useUserStore((state) => state.user);

        const userEmail = user?.email
            || user?.user?.email
            || user?.authResponse?.profile?.email
            || '';

    /* Allow cross origin in post request with boundary */  
    const headers = new Headers();
    headers.append('Accept', 'application/json');

    const submitHandler = (event) => {
        event.preventDefault(); 

        const uploadUrl = new URL(fileUploadUrl, window.location.origin);
        if (userEmail) {
            uploadUrl.searchParams.set('user_email', userEmail);
        }

        const uploadFormData = new FormData();
        if (formData && typeof formData.forEach === 'function') {
            formData.forEach((value, key) => {
                uploadFormData.append(key, value);
            });
        }
        if (userEmail) {
            uploadFormData.set('user_email', userEmail);
        }

        setIsUploading(true);

        fetch(uploadUrl.toString(), {
            method: 'POST',
            headers: headers,
            body: uploadFormData,
        })
        .then(async (response) => {
            const text = await response.text();
            if (!response.ok) {
                throw new Error(`Upload failed (${response.status} ${response.statusText}): ${text}`);
            }
            try {
                return JSON.parse(text);
            } catch (err) {
                throw new Error('Invalid JSON response from server: ' + (text ? text.slice(0, 500) : '(empty)'));
            }
        })
        .then(result => {
            console.log('Success:', result);
            setLogs(result);
            setRenderLogs(true);
        })
        .catch(error => {
            console.error('Error:', error);
            alert('Upload failed: ' + (error.message || error));
        })
        .finally(() => {
            setIsUploading(false);
        });
    }

    const handleChange = (event) => {
        if (isUploading) return; // ignore changes while uploading
        console.log(event.target.files[0]);
        const formData = new FormData();
        formData.append('file', event.target.files[0]);
        // Store selected file name for display
        if (event.target.files && event.target.files[0]) {
            setSelectedFileName(event.target.files[0].name);
        } else {
            setSelectedFileName('');
        }
        if (event.target.files[0].name.includes(".log")) {
            setRenderTraffic(true);
        } else {
            setRenderTraffic(false);
        }

        setFormData(formData);
    }

    if (renderLogs) {
            if (renderTraffic) {
                return (
                    <TrafficLogTable showtitlebar={true} rundate={logs.rundate} logdata={logs.entries}/>
                );
            } else {
                return (
                    <MusicLogTable showtitlebar={true} rundate={logs.rundate} logdata={logs}/>
                );
            }
    } else {
        return (
            <div className="lg:pl-72 sm:ml-0 px-0 sm:px-0">
            
            <Titlebar title="Manual Upload"/>

            <form method="post" encType="multipart/form-data" onSubmit={submitHandler}>
            {/* <form method="post" enctype="multipart/form-data" action="http://localhost:4000/upload"> */}
                <div className="m-8 flex col-span-full">

                    <Listbox value={selected} onChange={setSelected}>
                    <Label className="sr-only">Change published status</Label>
                    <div>
                        <div className="inline-flex divide-x divide-indigo-700 rounded-md outline-none">
                        <div className="w-24 inline-flex items-center gap-x-1.5 rounded-l-md bg-indigo-600 px-3 py-2 text-white">
                            <CheckIcon aria-hidden="true" className="-ml-0.5 size-5" />
                            <p className="text-sm font-semibold">{selected.title}</p>
                        </div>
                        <ListboxButton className="inline-flex items-center rounded-l-none rounded-r-md bg-indigo-600 p-2 outline-none hover:bg-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-400">
                            <span className="sr-only">Change published status</span>
                            <ChevronDownIcon aria-hidden="true" className="size-5 text-white forced-colors:text-[Highlight]" />
                        </ListboxButton>
                        </div>

                        <ListboxOptions
                        transition
                        className="absolute left-50 z-10 mt-2 w-72 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
                        >
                        {uploadOptions.map((option) => (
                            <ListboxOption
                            key={option.title}
                            value={option}
                            className="group cursor-default select-none p-4 text-sm text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
                            >
                            <div className="flex flex-col">
                                <div className="flex justify-between">
                                <p className="font-normal group-data-[selected]:font-semibold">{option.title}</p>
                                <span className="text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                                    <CheckIcon aria-hidden="true" className="size-5" />
                                </span>
                                </div>
                                <p className="mt-2 text-gray-500 group-data-[focus]:text-indigo-200">{option.description}</p>
                            </div>
                            </ListboxOption>
                        ))}
                        </ListboxOptions>
                    </div>
                    </Listbox>
            

                    { (selected.title === "Audio") ? (
                        <input
                        id="cart_number"
                        name="cart_number"
                        type="cart_number"
                        placeholder="Cart Number"
                        aria-label="Cart Number"
                        className="rounded-md w-64 bg-white ml-4 px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                    />
                    ) : (
                        <div></div>
                    )}
                </div>

                <div className="m-8 col-span-full"> 
                <label for="cover-photo" className="mt-4 block text-sm font-medium leading-6 text-gray-900">Music and Traffic Load</label>
                    <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
                    <div className="text-center">
                        {/* <div>filename: {selected.File.name}</div> */}
                                                                                                        <div className="flex items-center justify-center w-80 mx-auto gap-4">
                                                                                                            <div className="flex-shrink-0">
                                                                                                                <img src={(selected.title === "Audio") ? (music) : (logsicon)} className="h-12 w-12 text-gray-600" color="currentColor" alt="upload file" />
                                                                                                            </div>
                                                                                                              <div className="w-40 truncate text-sm text-gray-700 text-left">{selectedFileName || ''}</div>
                                                                                                        </div>
                        <div className="mt-4 flex text-sm leading-6 text-gray-600">
                            <label htmlFor="file-upload" className={`relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500 ${isUploading ? 'opacity-60 pointer-events-none' : ''}`}>
                                <span>{selected.direction}</span>
                                <input id="file-upload" name="file" type="file" onChange={handleChange} className="sr-only" disabled={isUploading} />
                            </label>
                            <p className="pl-1">or drag and drop</p>
                        </div>
                        <p className="text-xs leading-5 text-gray-600">{selected.file_specifics}</p>
                    </div>
                    </div>
                </div>

                                        <div className="mr-8 flex items-center justify-end gap-x-6">
                                        <button
                                            type="submit"
                                            disabled={isUploading}
                                            className={`rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm ${isUploading ? 'opacity-60 cursor-not-allowed' : 'hover:bg-indigo-500'} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                                        >
                                            {isUploading ? (
                                                <span className="inline-flex items-center gap-2">
                                                    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                                    </svg>
                                                    Uploading...
                                                </span>
                                            ) : (
                                                'Upload'
                                            )}
                                        </button>
                                </div>
            </form>

        </div>
        );

    }
}

export default ManualUpload;